import gql from "graphql-tag";
import { reportActionError } from "~/core/store/common/errors/handleStoreError.ts";
import { isocodesByCountry } from "./country_iso_codes";
export const state = () => ({
  zoneRequest: 0,
  zones: {
    content: [],
  },
  isocodesByCountry,
});
export const getters = {
  zones(state) {
    return state.zones;
  },
};
export const mutations = {
  beginZones(state) {
    state.zoneRequest += 1;
  },
  setZones(state, payload) {
    state.zones = payload;
  },
};
export const actions = {
  async zones(_ref, zoneData) {
    let { commit, state } = _ref;
    commit("beginZones");
    const request = state.zoneRequest;

    try {
      const { data } = await this.$vfapollo.query({
        query: gql`
          query ($page: Int, $size: Int, $country_id: String) {
            zonesList(page: $page, size: $size, country_id: $country_id) {
              content {
                id
                name
              }
              totalPages
              totalElements
              first
              last
              number
              numberOfElements
            }
          }
        `,
        variables: zoneData,
      });
      if (request === state.zoneRequest) commit("setZones", data.zonesList);
      return data.zonesList;
    } catch (e) {
      reportActionError({ commit }, e, { showNotification: true });
      return null;
    }
  },

  getISOCodeByCountryName({ state }, countryName) {
    if (!countryName) return "";
    return state.isocodesByCountry[countryName] || null;
  },
};
//# sourceMappingURL=paymentAddress.mjs.map
